export enum BioDocumentStep {
  INTRO,
  CAMERA_PERMISSION,
  CAPTURE_FRONT,
  REVIEW_FRONT,
  CAPTURE_BACK,
  REVIEW_BACK,
  VALIDATING,
  SUCCESS,
  ERROR,
  NO_CAMERA,
  // DNI validation rejected by the legacy/BIO document check (distinct from camera errors).
  VALIDATION_REJECTED,
  // Host (FileUpload) failed to upload the captured files to S3 / presigned URL.
  UPLOAD_FAILED,
}

export type BioDocumentSlot = 'front' | 'back';

// Result handed back to the host page; backend validation truth is tracked separately.
export interface BioDocumentCaptureResult {
  frontFile: File;
  backFile: File;
}
